/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_PlaceholderInputs */

const th_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหารายการแข่งขัน ทีม หรือผู้เล่น…`)
};

const en_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search events, teams, players…`)
};

const ja_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会・チーム・選手を検索…`)
};

const zh_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索赛事、球队、球员…`)
};

const es_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar eventos, equipos, jugadores…`)
};

const pt_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar eventos, times, jogadores…`)
};

const id_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari acara, tim, pemain…`)
};

const fr_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher événements, équipes, joueurs…`)
};

const tl_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng event, team, manlalaro…`)
};

const vi_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm sự kiện, đội, cầu thủ…`)
};

const ko_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트, 팀, 선수 검색…`)
};

const de_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events, Teams, Spieler suchen…`)
};

const ru_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск событий, команд, игроков…`)
};

const tr_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik, takım, oyuncu ara…`)
};

const it_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca eventi, squadre, giocatori…`)
};

const pl_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj wydarzeń, drużyn, zawodników…`)
};

const uk_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук подій, команд, гравців…`)
};

const hi_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन, टीमें, खिलाड़ी खोजें…`)
};

const ar_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث عن فعاليات أو فرق أو لاعبين…`)
};

const ms_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari acara, pasukan, pemain…`)
};

const bn_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন, দল, খেলোয়াড় খুঁজুন…`)
};

const zh_tw2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋賽事、球隊、球員…`)
};

const zh_hk2_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋賽事、球隊、球員…`)
};

const ur_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ، ٹیمیں، کھلاڑی تلاش کریں…`)
};

const fa_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جست‌وجوی رویداد، تیم، بازیکن…`)
};

const sw_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tafuta matukio, timu, wachezaji…`)
};

const nl_search_placeholder = /** @type {(inputs: Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoek evenementen, teams, spelers…`)
};

/**
* | output |
* | --- |
* | "Search events, teams, players…" |
*
* @param {Search_PlaceholderInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const search_placeholder = /** @type {((inputs?: Search_PlaceholderInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_PlaceholderInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_search_placeholder(inputs)
	if (locale === "ja") return ja_search_placeholder(inputs)
	if (locale === "zh") return zh_search_placeholder(inputs)
	if (locale === "es") return es_search_placeholder(inputs)
	if (locale === "pt") return pt_search_placeholder(inputs)
	if (locale === "id") return id_search_placeholder(inputs)
	if (locale === "fr") return fr_search_placeholder(inputs)
	if (locale === "tl") return tl_search_placeholder(inputs)
	if (locale === "vi") return vi_search_placeholder(inputs)
	if (locale === "ko") return ko_search_placeholder(inputs)
	if (locale === "de") return de_search_placeholder(inputs)
	if (locale === "ru") return ru_search_placeholder(inputs)
	if (locale === "tr") return tr_search_placeholder(inputs)
	if (locale === "it") return it_search_placeholder(inputs)
	if (locale === "pl") return pl_search_placeholder(inputs)
	if (locale === "uk") return uk_search_placeholder(inputs)
	if (locale === "hi") return hi_search_placeholder(inputs)
	if (locale === "ar") return ar_search_placeholder(inputs)
	if (locale === "ms") return ms_search_placeholder(inputs)
	if (locale === "bn") return bn_search_placeholder(inputs)
	if (locale === "zh-TW") return zh_tw2_search_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_search_placeholder(inputs)
	if (locale === "ur") return ur_search_placeholder(inputs)
	if (locale === "fa") return fa_search_placeholder(inputs)
	if (locale === "sw") return sw_search_placeholder(inputs)
	if (locale === "nl") return nl_search_placeholder(inputs)
	return en_search_placeholder(inputs)
});